import api from './api';
import { getTimelineUrlId } from '../utils/slugUtils';

// Get all public timelines
const getPublicTimelines = async (sort = 'newest') => {
  const response = await api.get('/api/timelines/public', {
    params: { sort }
  });
  return response.data;
};

// Get all timelines
const getTimelines = async () => {
  const response = await api.get('/api/timelines');
  return response.data;
};

// Get a specific timeline
const getTimelineById = async (id) => {
  const response = await api.get(`/api/timelines/${id}`);
  return response.data;
};

// Create a new timeline
const createTimeline = async (timelineData) => {
  const response = await api.post('/api/timelines', timelineData);
  return response.data;
};

// Update a timeline
const updateTimeline = async (id, timelineData) => {
  const response = await api.put(`/api/timelines/${id}`, timelineData);
  return response.data;
};

// Delete a timeline
const deleteTimeline = async (id) => {
  const response = await api.delete(`/api/timelines/${id}`);
  return response.data;
};

// Increment view count for a timeline
const incrementTimelineView = async (id) => {
  try {
    // Fire-and-forget request
    await api.post(`/api/timelines/${id}/view`);
  } catch (error) {
    console.error('Failed to increment timeline view count:', error);
  }
};

// Helper function to get the preferred URL identifier for a timeline
const getTimelineUrlIdentifier = (timeline) => {
  return getTimelineUrlId(timeline);
};

const timelineService = {
  getPublicTimelines,
  getTimelines,
  getTimelineById,
  createTimeline,
  updateTimeline,
  deleteTimeline,
  incrementTimelineView,
  getTimelineUrlIdentifier,
};

export default timelineService; 